import { Link } from "react-router-dom";
import { RegisterForm } from "../../components/Form/RegisterForm";
import { LogoContent } from "../../components/LogoSection";
import { StyledTitle } from "../../style/typography";
import { RegisterWrapper } from "./style";

export const RegisterPage = () => {
  return (
    <RegisterWrapper>
      <div>
        <section>
          <LogoContent />
        </section>
        <section>
          <div>
            <StyledTitle tag="heading3" titleStyle="heading3">
              Cadastro
            </StyledTitle>
            <Link to="/">Retornar para o login</Link>
          </div>
          <RegisterForm />
        </section>
      </div>
    </RegisterWrapper>
  );
};
